import { ErrorMessage } from "./index";

export interface InputFieldCollection<T> {
    values: T;
    isValid: boolean;
    isEditable: boolean;
    errorMessages: ErrorMessage[];
}